import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { HeaderComponent } from "./components/header/header.component";
import { RouterModule } from "@angular/router";
import { DateagoPipe } from "./pipes/dateago.pipe";
import { SafePipe } from "./pipes/safe.pipe";
import { TransformPipe } from "./pipes/transform.pipe";
import { MatchingPipe } from "./pipes/matching.pipe";
import { PhonePipe } from "./pipes/phone.pipe";
import { AdjustFontSizePipe } from "./pipes/adjustFontSize.pipe";

@NgModule({
  declarations: [HeaderComponent, DateagoPipe, SafePipe, TransformPipe, MatchingPipe],
  imports: [IonicModule, CommonModule, FormsModule, RouterModule],
  exports: [HeaderComponent, DateagoPipe, SafePipe, TransformPipe, MatchingPipe],
})
export class ComponentsModule {}
